/**
 * @module getActionableMessageHttpChannelUrl
 */

import { format } from 'owa-localize';
import { MessageContext } from 'owa-actionable-message-v2';

import { getActionEndpointUrlFromStore } from '../selectors/getActionEndpoint';

/**
 * @constant
 * A url format for execute action channel
 */

const ACTION_CHANNEL_URL_FORMAT = '{0}/{1}/messages/{2}/adaptiveCardV2/action';

/**
 * @constant
 * A default userId for a mailbox of type user
 */

const USER_ID = 'userid';

/**
 * @function
 * To get the http channel url for Actionable Messages
 * @param {MessageContext} messageContext - A message context object
 * @returns A http channel url for Actionable Messages
 */

const getActionableMessageHttpChannelUrl = (messageContext: MessageContext): string => {
    const actionEndpointUrl = getActionEndpointUrlFromStore();
    const userId =
        messageContext.mailboxInfo?.type !== 'UserMailbox'
            ? messageContext.mailboxInfo?.mailboxSmtpAddress
            : USER_ID;
    const itemId = messageContext.odataItemId;
    return format(ACTION_CHANNEL_URL_FORMAT, actionEndpointUrl, userId, itemId);
};

export default getActionableMessageHttpChannelUrl;
